import React from 'react';
import { inject, observer } from 'mobx-react';
import H5UserList from './h5';
import PCUserList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
interface UserListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    currentPage?: number;
    pageSize?: number;
    data?: any
    namespace?: string; // 允许外部指定 listStore 命名空间，默认 userList
    listStore?: any; // 允许外部传入自定义 listStore（例如 topic.listStore）
    userList: any   // 用户列表
    createFollowUserCallBack?: any  // 关注用户
    followDeleteCallBack?: any  // 取消关注用户
    searchKeyword?: any
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式

}
type UserListAllProps = UserListProps & RouteComponentProps;
interface UserListState {
    userList: any
}
@inject('app', 'site', 'user')
@observer
class UserList extends React.Component<UserListAllProps, UserListState> {
    constructor(props) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            userList: props.userList || [],
        };
    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑


    }

    componentDidUpdate(prevProps) {
        // 当 props.userList 变化时更新 state
        if (prevProps.userList !== this.props.userList) {
          this.setState({
            userList: this.props.userList || []
          });
        }
      }

    // 关注用户
    createFollowUser = (item, index) => {
        console.log('关注调接口', item, index)
        const { user, createFollowUserCallBack } = this.props;
        let { userList } = this.state;
        if (user) {
            let params: any = {
                toUserCode: item?.code
            }
            user.createFollowUser(params).then(res => {
                if(res.code == 0) {
                    const updatedList = userList.map((userItem, idx) => {
                        if (idx === index) {
                            return {
                                ...userItem,  // 复制原对象所有属性
                                isFollow: true,  // 更新 isFollow
                            };
                        }
                        return userItem;
                    });
                    createFollowUserCallBack && createFollowUserCallBack(item, index);
                    
                    // 正确的状态更新
                    this.setState({
                        userList: updatedList
                    });
                }
                
            })

        }
    }

    // // 取消关注用户
    followDelete = (item, index) => {
        console.log('取消关注调接口', item, index)
        let { userList } = this.state;
        const { user, followDeleteCallBack } = this.props;
        if (user) {
            let params: any = {
                code: item?.code,
                type: 1
            }
            user.followDelete(params).then(res => {
                if(res.code == 0) {
                    const updatedList = userList.map((userItem, idx) => {
                        if (idx === index) {
                            return {
                                ...userItem,  // 复制原对象所有属性
                                isFollow: false,  // 更新 isFollow
                            };
                        }
                        return userItem;
                    });
                    followDeleteCallBack && followDeleteCallBack(item, index);
                    
                    // 正确的状态更新
                    this.setState({
                        userList: updatedList
                    });
                }
            })
        }
    }


    // // 处理触底加载下一页
    // handleLoadMore = () => {
    //     const { thread, namespace = 'threadList' } = this.props;
    //     if (!thread) return;

    //     const list = thread.listStore.lists[namespace];
    //     if (!list) return;

    //     // 获取当前页码，默认从1开始
    //     const currentPage = list.attribs?.page || 1;
    //     const pageSize = list.attribs?.pageSize || 20;

    //     // 构建查询参数并加载下一页
    //     const params: any = {
    //         'page[number]': currentPage + 1,
    //         'page[size]': pageSize,
    //     };

    //     // 如果有其他查询条件（如分类过滤），也需要传递
    //     if (list.search?.filter) {
    //         params.filter = list.search.filter;
    //     }

    //     // 根据命名空间调用对应的接口；目前只有 threadList 走 getThreadList
    //     if (namespace === 'threadList') {
    //         thread.getThreadList(params);
    //     }
    // };


    // 去个人中心
    goUser = (user) => {
        console.log('跳转用户中心');
        if (this.props.history && user.code) {
            // this.props.history.push(`/user/${user.code}`);
            window.open(`/user/${user.code}`);
        }
    }

    render() {
        const { site, app, data, onLoadMore, loading: propsLoading, hasMore: propsHasMore, searchKeyword, loading, hasMore, listStore, emptyText,  emptyIcon, emptyBoxStyle, ...props } = this.props;
        const platform = app?.platform || 'h5';
        let { userList } = this.state;
        // 确保传递 data 属性，即使为空数组
        const postListData = data || [];

        // 优先使用父组件传递的 loading 和 hasMore，如果没有则从 thread store 获取
        // const store = listStore || user?.listStore;
        // const loading = propsLoading !== undefined ? propsLoading : (store?.lists[namespace]?.loading || false);
        // const hasMore = propsHasMore !== undefined ? propsHasMore : (store?.lists[namespace]?.hasMore ?? true);

        // 优先使用父组件传递的 onLoadMore，如果没有则使用默认的 handleLoadMore
        // const loadMoreHandler = onLoadMore || this.handleLoadMore;

        if (platform === 'pc') {
            return <PCUserList
                createFollowUser={this.createFollowUser}
                followDelete={this.followDelete}
                goUser={this.goUser} {...props}
                data={postListData}
                userList={userList}
                loading={loading}
                hasMore={hasMore}
                onLoadMore={onLoadMore}
                searchKeyword={searchKeyword}
                emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
             />;
        } else {
            return <H5UserList
            createFollowUser={this.createFollowUser}
            followDelete={this.followDelete}
            {...props} goUser={this.goUser}
            userList={userList}
            data={postListData}
            loading={loading}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
            searchKeyword={searchKeyword}
            emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
        />;
        }
    }
}

export default withRouter(UserList);